import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@ant-design/v5-patch-for-react-19';

import { AuthProvider } from './contexts/AuthContext';
import MasterLayout from './components/MasterLayout';
import PrivateRoute from './components/PrivateRoute';

import { ConfigProvider, App as AntdApp, Spin } from 'antd';
import viVN from 'antd/es/locale/vi_VN';

// =========================
// Lazy load pages
// =========================

const Login = lazy(() => import('./pages/Login'));

const UserManagement = lazy(
  () => import('./pages/admin/UserManagement')
);

const TableCal = lazy(
  () => import('./pages/TableCal')
);

const Configuation = lazy(
  () => import('./pages/Configuration')
);

const SheetPile = lazy(
  () => import('./pages/SheetPile')
);

const Pile = lazy(
  () => import('./pages/Pile')
);

const HaloCore = lazy(
  () => import('./pages/HaloCore')
);

const Ibeam = lazy(
  () => import('./pages/I-beam')
);

const Precast = lazy(
  () => import('./pages/Precast')
);

const EuroWall = lazy(
  () => import('./pages/EuroWall')
);

const ManageCostMaterial = lazy(
  () => import('./pages/ManageCostMaterial')
);

const PileSquare = lazy(
  () => import('./pages/PileSquare')
);

// =========================
// Loading component
// =========================

function PageLoading() {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        minHeight: '300px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spin size="large" tip="Đang tải..." />
    </div>
  );
}

function App() {
  return (
    <ConfigProvider locale={viVN}>
      <AntdApp>
        <AuthProvider>
          <BrowserRouter>
            <Suspense fallback={<PageLoading />}>
              <Routes>

                {/* Login */}
                <Route
                  path="/login"
                  element={<Login />}
                />

                {/* Main */}
                <Route
                  path="/"
                  element={
                    <PrivateRoute>
                      <MasterLayout />
                    </PrivateRoute>
                  }
                >
                  <Route
                    index
                    element={<TableCal />}
                  />

                  <Route
                    path="pile"
                    element={<Pile />}
                  />

                  <Route
                    path="sheetpile"
                    element={<SheetPile />}
                  />

                  <Route
                    path="I-beam"
                    element={<Ibeam />}
                  />

                  <Route
                    path="halocore"
                    element={<HaloCore />}
                  />

                  <Route
                    path="precast"
                    element={<Precast />}
                  />

                  <Route
                    path="eurowall"
                    element={<EuroWall />}
                  />

                  <Route
                    path="squarepile"
                    element={<PileSquare />}
                  />

                  <Route
                    path="managecostmaterial"
                    element={<ManageCostMaterial />}
                  />

                  <Route
                    path="configuration"
                    element={<Configuation />}
                  />
                </Route>

                {/* Admin */}
                <Route
                  path="/admin"
                  element={
                    <PrivateRoute>
                      <MasterLayout />
                    </PrivateRoute>
                  }
                >
                  <Route
                    index
                    element={<UserManagement />}
                  />
                </Route>

              </Routes>
            </Suspense>
          </BrowserRouter>
        </AuthProvider>
      </AntdApp>
    </ConfigProvider>
  );
}

export default App;